import React, {memo, useEffect, useState} from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {Tooltip} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import LockIcon from '@mui/icons-material/Lock';
import Grid from "@mui/material/Grid";
import {toast} from "react-toastify";
import MenuItem from "@mui/material/MenuItem";
import Api from "../../utils/api";
import {roleAction, userAction} from "../../actions";
import {connect, useDispatch} from "react-redux";
import {USER_FETCH} from "../../types";
import Typography from "@mui/material/Typography";
import EditIcon from '@mui/icons-material/Edit';

const UserEdit = memo((props) => {

    /**
     * user props from component props call, int id
     * fetchUser action load user data from redux
     * userReducer and roleReducer access to data
     */
    const { user, fetchUser, userReducer, roleReducer, reload, fetchRoles, roles } = props;

    const dispatch = useDispatch();

    // init state form
    const initStat = {
        name: '',
        family: '',
        mobile: '',
        email: '',
        username: '',
        role_id: '',
        status: ''
    }


    const [form, setForm] = useState(initStat);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);


    useEffect(() => {
        // remove old user from redux
        dispatch({type: USER_FETCH, payload: null});
        // set form with init state
        setForm(initStat);
        // fetch new user if dialog is open
        if (open === true) {
            fetchUser(user);
            fetchRoles();
        }
    }, [open]);


    useEffect(() => {
        if (userReducer.user) {
            setForm({
                name: userReducer.user.name,
                family: userReducer.user.family,
                mobile: userReducer.user.mobile,
                email: userReducer.user.email,
                username: userReducer.user.username,
                role_id: userReducer.user.role.id,
                status: userReducer.user.status
            })
        }
    }, [userReducer.user]);



    const handleChangeElement = (event) => {
        let frm = {...form};
        frm[event.target.name] = event.target.value;
        setForm(frm);
    };


    const handleSubmit = (event) => {
        event.preventDefault();

        setLoading(true);

        new Api().put('/users/' + user, form).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    setOpen(false);
                    reload()
                } else {
                    toast.error(response.msg);
                }
            }

            setLoading(false);
        })

    }


    return (
        <div>
            <Tooltip title="ویرایش">
                <IconButton onClick={() => setOpen(true)}>
                    <EditIcon />
                </IconButton>
            </Tooltip>
            <Dialog fullWidth={true} open={open} aria-labelledby="form-dialog-title">
                <form dir='rtl' onSubmit={handleSubmit}>
                    <DialogTitle id="form-dialog-title">ویرایش اطلاعات</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    label="نام"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    value={form.name}
                                    name='name'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="نام خانوادگی"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    value={form.family}
                                    name='family'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="موبایل"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='mobile'
                                    value={form.mobile}
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="username"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='username'
                                    value={form.username}
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="ایمیل"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='email'
                                    value={form.email}
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    select
                                    label="وضعیت"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='status'
                                    value={form.status}
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={form.status}
                                >
                                    <MenuItem value={1}>فعال</MenuItem>
                                    <MenuItem value={0}>غیرفعال</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} >
                                <TextField
                                    select
                                    label="نقش"
                                    variant="outlined"
                                    value={form.role_id}
                                    margin='dense'
                                    fullWidth
                                    name='role_id'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeElement}
                                >
                                    <MenuItem key={0} value={0}>انتخاب</MenuItem>
                                    {roles && roles.data && roles.data.map((role, index) => {
                                        return <MenuItem key={index} value={role.id}>{role.title ? role.title : role.id}</MenuItem>
                                    })}
                                </TextField>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button color="primary" onClick={() => setOpen(false)}>
                            انصراف
                        </Button>
                        <Button disabled={loading} color="primary" autoFocus type='submit'>
                            ارسال اطلاعات
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    );

})


const mapStateToProps = state => ({
    userReducer: state.userReducer,
    roles: state.roleReducer,

});

const mapDispatchToProps = (dispatch) => ({
    fetchRoles: () => {
        dispatch(roleAction.fetchRoles())
    },
    fetchUser: (id) => {
        dispatch(userAction.fetchUser(id))
    }
});



export default connect(mapStateToProps, mapDispatchToProps)(UserEdit)